import styled from 'styled-components';

import { breakpoint } from '@/themes/breakpoints';

import { IconButton } from '../IconButton';

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type PaginationButtonProps = {
  $isActive: boolean;
}

export const PaginationButton = styled(IconButton)<PaginationButtonProps>`
  min-width: auto;
  border-color: ${({
    theme,
    $isActive,
  }) => `${$isActive ? theme.colors.black : theme.colors.neutral[200]} !important`};
  background-color: ${({
    theme,
    $isActive,
  }) => ($isActive ? theme.colors.white : theme.colors.neutral[200])};
`;

export const PageNumber = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 2px;

  @media ${breakpoint.sm} {
    width: 32px;
    height: 32px;
  }
`;

export const PaginationElementsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;
